export const PRINCIPLE_COLORS = [
  '#015ccf',
  '#64cb00',
  '#01a0fe',
  '#abf000',
  '#5ec9a5',
  '#feff01'
]

export const FAQ_COLORS = [
  '#015aaa',
  '#007ec5',
  '#00aeef',
  '#009fb4',
  '#5cc3b6',
  '#00a895',
  '#80ca9c',
  '#00a54f',
  '#00854a',
  '#71bf44',
  '#bed630'
]

export const HIGH_CONTRAST_COLOR = '#1a1a1a'
